export var SEARCH_CLASS_PREFIX = 'Search';
export var searchRoot = 'SearchRoot';
export var initialCursor = 0;